import axios, { AxiosRequestConfig } from 'axios'
import { AdminAction, AdminActionRequest } from './AdminTools.actions'

/** No Content-Type: axios leaves a FormData body's multipart boundary to the browser. */
export const requestOptions = (action: AdminAction, request: AdminActionRequest): AxiosRequestConfig => {
  const options: AxiosRequestConfig = { params: request.params, timeout: 35_000 }
  if (request.accept) options.headers = { Accept: request.accept }
  if (action.download) options.responseType = 'blob'
  return options
}

export const filenameFromContentDisposition = (header: string | undefined, fallback: string): string =>
  header?.match(/filename="?([^";]+)"?/i)?.[1]?.trim() || fallback

const readBlobText = (blob: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(String(reader.result))
    reader.onerror = () => reject(reader.error)
    reader.readAsText(blob)
  })

export const decodeBlobErrorBody = async (error: unknown): Promise<unknown> => {
  const response = axios.isAxiosError(error) ? error.response : undefined
  if (response?.data instanceof Blob) {
    const text = await readBlobText(response.data).catch(() => undefined)
    if (text === undefined) return error
    try {
      response.data = JSON.parse(text)
    } catch {
      response.data = text
    }
  }
  return error
}
